// @ts-nocheck

import * as basketsActions from './basket';
import * as immersiveActions from './immersive';

export default {
  ...basketsActions,
  ...immersiveActions,
};
